












































































































import { IntlMixin } from 'vuemixins/intl_mixin'
import BaseIcon from 'vuecomponents/base_icon.vue'
import MultilineInput from 'vuecomponents/multiline_input.vue'
import RelativeTime from 'library/v4/components/relative-time.vue'
import AvatarImage from 'vuecomponents/avatar_image.vue'
import OzButton from 'library/v4/components/oz-button.vue'
import { Component, Mixins, Prop } from 'vue-property-decorator'
import { namespace, State, Getter } from 'vuex-class'
import { Comment, Id, User } from 'types'

@Component({
  components: { BaseIcon, AvatarImage, MultilineInput, RelativeTime, OzButton },
})
export default class SurfacePostCommentNew extends Mixins(IntlMixin) {
  $refs!: {
    editCommentInput: MultilineInput & {
      $el: HTMLTextAreaElement
    }
  }
  @Prop() id!: Id
  @Prop() comment!: Comment & { html_body: any }
  @Prop() isBeingEdited!: boolean
  @Getter colorScheme!: 'dark' | 'light'
  @Getter isStream!: boolean
  @State user!: User
  @Getter canIModerate!: boolean
  @(namespace('userContributor').Getter) getUserById

  get author() {
    return this.getUserById(this.comment.user_id) || this.user
  }
  get isRegistered() {
    return this.author.registered || !!this.author.registered_at
  }
  get hyperlinkedBody() {
    return this.comment.html_body || this.comment.body
  }
  get showActions() {
    return (this.user.id === this.comment.user_id || this.canIModerate) && !this.isBeingEdited
  }
  mounted() {
    this.fetchUser(this.comment.user_id)
  }
  updated() {
    if (this.isBeingEdited) {
      this.$refs.editCommentInput.focus()
    }
  }
  @(namespace('userContributor').Action) fetchUser
  get authorName() {
    return this.isRegistered ? this.author.name || this.author.username : this.__('Anonymous')
  }
  toggleDropdown() {
    this.$emit('show-comment-action-menu')
  }
  onEscape() {
    if (this.isBeingEdited) {
      this.$emit('stop-editing')
    }
  }
  onOutsideClick() {
    if (this.isBeingEdited) {
      this.$emit('stop-editing')
    }
  }
  submitEdit() {
    let newBody = this.$refs.editCommentInput.$el.value
    if (newBody?.trim() !== '') {
      this.$emit('edit', {
        id: this.id,
        body: newBody,
      })
    }
  }
}
